import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AyudaComponent} from './ayuda.component';


@NgModule({
  declarations: [
    AyudaComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    AyudaComponent
  ]
})
export class AyudaModule {
}
